import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { DEFAULT_META } from '../../constants/meta';

import { DEFAULT_PAGINATION } from '../../constants/pagination';
import {
  fetchGetAgencies,
  IGetAgenciesRequest,
  TGetAgenciesResponse,
} from '../../repositories/agent-catalog-search/v2/get-agencies';

export interface IGetAgenciesDeps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export const defaultData = {
  items: [],
  meta: DEFAULT_META,
  ...DEFAULT_PAGINATION,
};

export function getAgencies(deps: IGetAgenciesDeps, parameters: IGetAgenciesRequest) {
  const { httpApi, logger } = deps;

  return fetchGetAgencies({
    httpApi,
    parameters,
  })
    .then((res: TGetAgenciesResponse) => {
      if (res.statusCode === 200) {
        return res.response;
      }

      logger.warning('Bad request agent-catalog-search/v2/get-agencies');

      return defaultData;
    })
    .catch(error => {
      logger.error(error);

      return defaultData;
    });
}
